import constants from "../../../../constants";
import React, { useContext, useEffect } from "react";
import BackSvgIcon from "../../../../Svg/BackSvgIcon";
import CodingTable from "../../CodingPage/CodingTable";
import TestDueHooks from "../../../../Hooks/TestDueHooks";
import AlertContext from "../../../../context/AlertContext";
import StatusLabel from "../../../CommonComponents/StatusLabel";
import TestDueDate from "../../../CommonComponents/TestDueDate";
import WarningNotice from "../../InstructionPage/WarningNotice";
import AssignmentPage from "../../AssignmentPage/AssignmentPage";
import InstructionPage from "../../InstructionPage/InstructionPage";
import WarningNoticeHooks from "../../../../Hooks/WarningNoticeHooks";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import WarningNoticeBodySvgIcon from "../../../../Svg/WarningNoticeBodySvgIcon";
import { useLocation, useParams } from "react-router-dom";

export default function RightMain() {
  const Alert = useContext(AlertContext);

  const { currentDueLabel } = TestDueHooks();
  const { id } = useParams();
  const { pathname } = useLocation();
  const WarningNoticeHks = WarningNoticeHooks();
  const { checkBatchType } = useCommonFunctionHooks();
  const isPreview =
    new URLSearchParams(window.location.search).get("mode") === "preview";
  // console.log("Alert.showBreadCrumbsData?.from", Alert.showBreadCrumbsData?.from);

  const handleBackFromAssignment = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    if (Alert.isFromProfile.current) {
      Alert.navigate("/profiles/testpoints");
    } else if (Alert.isAdmin) {
      if (Alert.testData.mockuse) {
        Alert.navigate(
          `batches/${sessionStorage.getItem(
            "abatchid",
          )}/dashboard?scope-ar=mock-test`,
        );
      }
      else {
        Alert.navigate(
          `batches/${sessionStorage.getItem(
            "abatchid",
          )}/path/${sessionStorage.getItem("aPathId")}/report#`,
        );
      }
    } else if (Alert.testData.ainterview) {
      Alert.navigate("main/interview/library");
    } else if (Alert.testData.mockuse) {
      if(Alert.testData.scope=="COMPANY") Alert.navigate("main/company_specific/library");
      else if (Alert.testData.scope=="TECH") Alert.navigate("main/technology_specific/library");
      else Alert.navigate("main/mock/library");
    } else if (Alert.testData.single) {
      if(Alert.testData.random) Alert.navigate(`/main/cc`);
      else Alert.navigate(`/main/cc/section/${Alert.testData.secid}`);
    } else if (Alert.showBreadCrumbsData?.from === "user") {
      Alert.setShowPopup(true);
      Alert.navigate(`batches/${sessionStorage.getItem("abatchid")}/users`);
    } else if (Alert.showBreadCrumbsData?.from === "old") {
      Alert.navigate(`batches/${sessionStorage.getItem("abatchid")}/report`);
    } else if (Alert.showBreadCrumbsData?.from === "learner") {
      Alert.navigate("/main/dashboard/testresults");
    } else {
      Alert.navigate(
        `batches/${sessionStorage.getItem(
          "abatchid"
        )}/path/${sessionStorage.getItem("aPathId")}/report#`,
      );
    }
  };

  const showWarningNotice = () => {
    return (
      WarningNoticeHks.showWarningForAssessment() ||
      (!Alert.isAdmin &&
        !localStorage.getItem("mockLp") &&
        Alert.lpData.batchType !== constants.BATCH_TYPE.SELF &&
        Alert.status !== constants.PROGRESS_STATUS.EVALUATED &&
        currentDueLabel(Alert.testData.duedate) === "Past Due" &&
        Alert.status !== constants.PROGRESS_STATUS.TO_BE_EVALUATED) ||
      ((Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
        Alert.status === constants.PROGRESS_STATUS.IN_PROGRESS ||
        Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED) &&
        (Alert.testData.testtype === constants.libTypeIds.MCQ ||
          Alert.testData.testtype === constants.libTypeIds.SQL ||
          Alert.testData.testtype === constants.libTypeIds.DESCRIPTIVE ||
          Alert.testData.testtype === constants.libTypeIds.CODING_SNIPPET))
    );
  };

  useEffect(() => {
    window.electronAPI?.getAppVersion().then((data) => {
      const currentVersion = data.version;
      const latestVersion = process.env.REACT_APP_DESKTOP_APP_LATEST_VERSION;

      Alert.setIsVersionUpToDate(currentVersion !== latestVersion);
    });
  }, []);

  return (
    <div className="rightMainContainer">
      {(Alert.testData.single ||
        Alert.testData.mockuse ||
        ((Alert.isFromProfile.current ||
          (Alert.isAdmin && !Alert.isFromProfile.current)) &&
          Alert.testData.testtype === constants.libTypeIds.ASSIGNMENT)) && (
          <div className="rightMainBack">
            <BackSvgIcon onClick={handleBackFromAssignment} />
          </div>
        )}
      <div className="rightMainHeader">
        <div className="rightMainHeaderInnerDiv">
          <span className="rightMainHeaderTestLabel">
            {Alert.testData.single
              ? "Coding Challenge"
              : Alert.testData.testname !== null
                ? Alert.testData.testname
                : Alert.testData.libname}
          </span>
          {!Alert.testData.ainterview &&
            !Alert.testData.mockuse &&
            !Alert.testData.single &&
            !isPreview && <StatusLabel component={"rightMain"} />}
        </div>
        {!Alert.isAdmin &&
          !checkBatchType() &&
          !localStorage.getItem("mockLp") &&
          !Alert.testData.hasOwnProperty("single") &&
          Alert.showBreadCrumbsData.from !== "learner" &&
          Alert.lpData.batchType !== constants.BATCH_TYPE.SELF &&
          !Alert.testData.hasOwnProperty("mockuse") && <TestDueDate />}
      </div>
      {showWarningNotice() ? (
        <div>
          <WarningNotice />
          {/* {(Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
            Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
            Alert.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED) &&
            (Alert.testData.testtype === constants.libTypeIds.MCQ ||
              Alert.testData.testtype === constants.libTypeIds.DESCRIPTIVE) && (
              <WarningNoticeBodySvgIcon component="rightMain" />
            )} */}
        </div>
      ) : (
        <>
          {(Alert.showInstruction ||
            (isPreview &&
              Alert.testData.testtype &&
              Alert.testData.testtype !==
              constants.libTypeIds.CODING_CHALLENGE)) &&
            Alert.status !== constants.PROGRESS_STATUS.EVALUATED && (
              <InstructionPage />
            )}
          {!Alert.showInstruction &&
            Alert.testData.testtype === constants.libTypeIds.CODING_CHALLENGE ? (
            <CodingTable />
          ) : (
            (Alert.isFromProfile.current ||
              Alert.showBreadCrumbsData.from === "learner" ||
              (Alert.isAdmin && !Alert.isFromProfile.current && !isPreview)
              ? Alert.testData.testtype === constants.libTypeIds.ASSIGNMENT
              : Alert.testData.libtype === constants.libTypeIds.ASSIGNMENT) && (
              <AssignmentPage />
            )
          )}
        </>
      )}
    </div>
  );
}
